module.exports = __webpack_public_path__ + "img/export.94bb1aaf.svg";